var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vs-button',{staticClass:"timer",attrs:{"disabled":"","type":"filled"}},[_c('b-icon',{attrs:{"icon":"alarm"}}),_vm._v(" "),_c('span',{staticClass:"timerColor"},[_vm._v(_vm._s(_vm.showTimer)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }